import './InviteStudentDrawer.scss';

import * as React from 'react';

import { escape as escapeHtml } from 'lodash';

import { FeatureUseEventAdapter } from '~analytics/adapters/FeatureUseEventAdapter';
import { translate } from '~l10n/client';
import { Dialog } from '~shared/components/Dialog';
import { useGenerateShareUrl } from '~shared/components/QrCode';
import { QrCode } from '~shared/components/QrCode/QrCode';
import { useQrCodeMaxWidth } from '~shared/components/QrCode/useQrCodeMaxWidth';
import { Spinner } from '~shared/components/Spinner';
import { useRoomDetail } from '~teacher/hook/room/useRoomDetail';

import {
  useInviteStudentsDrawer,
  useInviteStudentsDrawerDispatch,
} from './InviteStudentDrawerContext';

interface Props {
  roomId: number;
}

const MAX_SHARE_ROOM_QR_CODE_WIDTH = 420;

export function InviteStudentDrawer(props: Props) {
  const isOpen = useInviteStudentsDrawer();
  const dispatch = useInviteStudentsDrawerDispatch();

  const onClose = () => {
    new FeatureUseEventAdapter({
      feature: 'invite_student_drawer',
      action: 'close',
    }).sendAnalytics();

    dispatch('Close');
  };

  return (
    <Dialog
      position="right"
      open={isOpen}
      size="large"
      showBackdrop={false}
      id="invite-student-drawer"
      onClose={onClose}
      closeLabel={translate('Close')}
      title={translate('Invite Students')}
    >
      {isOpen ? <InviteStudentDrawerContent {...props} /> : null}
    </Dialog>
  );
}

function getGoHostName() {
  try {
    const goUrl = new URL(window.APP_CONFIG.GO_URL);
    const goHostName = goUrl.hostname;
    return goHostName;
  } catch {
    return '';
  }
}

function InviteStudentDrawerContent({ roomId }: Props) {
  const roomDetail = useRoomDetail({
    roomId,
  });
  const qrCodeWidth = useQrCodeMaxWidth(MAX_SHARE_ROOM_QR_CODE_WIDTH);

  useGenerateShareUrl(roomId);
  const goHostName = getGoHostName();

  return (
    <>
      <div className="flex flex-col py-5 ">
        <div className="font-display text-lg leading-14 text-center p-8 pt-10 ">
          <span
            className="font-500  text-blue-900"
            dangerouslySetInnerHTML={{
              __html: translate(
                'Visit <span class=\"go-socrative-url\">{0}</span> and enter room name <span class=\"room-large-name\">{1}</span>' /* eslint-disable-line */ /* prettier-ignore */
              ).format(goHostName, escapeHtml(roomDetail.data?.name)),
            }}
          />
        </div>
      </div>
      <div className="flex justify-center">
        <div>
          {roomDetail.data?.url ? (
            <QrCode
              key={`${qrCodeWidth}-${roomDetail.data?.url}`}
              text={roomDetail.data?.url + '?method=qr'}
              size={qrCodeWidth}
            />
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    </>
  );
}
